// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"28d0f13b","977":"bbe75f25"}[chunkId] + ".chunk.js";
};